import { startLoading, endLoading } from '../app-dux';
import recognitionService from '../../services/recognition';
import { getSelectedPeople } from '../../components/recognize/people/selectors';
import { getSelectedBehaviorId, getSelectedProgram } from '../../components/recognize/program/selectors';
import { getMessage, getPrivate, getSelectedEcard } from '../../components/recognize/message/selectors';
import { getUser } from '../../app-auth';
import { SET_ERRORS } from '../app-dux';
import * as types from './types';


const selectedProgram = ( state ) => getSelectedProgram( state );

export const clearRecognition = () => ( { type: types.CLEAR_RECOGNITION } );
export function submitRecognition( source, submitState ) {
    return async ( dispatch, getState ) => {
        dispatch( { type: SET_ERRORS, errors: [] } );
        const authState = await getUser();
        if ( authState && authState.claims && authState.claims.person_id )
        {
            dispatch( startLoading() );
            const state = getState();
            const recognition = {
                senderPersonId: authState.claims.person_id,
                source,
                state: submitState,
                recipients: buildRecipientList( state ),
                sharedSelections: buildSharedSelections( state )
            };
            return recognitionService.createRecognition( recognition )
            .then( data => {
                dispatch( endLoading() );
                dispatch( { type: SET_ERRORS, errors: data.errors } );
                return data;
            } ).catch( error => {
                console.error( error );
                dispatch( endLoading() );
                return error;
            } );
        }
        return { errors: 'missing participant' };
    };  
}

const buildRecipientList =  ( state ) => {
    const selectedPeople = getSelectedPeople( state );
    let recipientList = [];
    for ( let i = 0; i < selectedPeople.length; i++ ) {
        const recipient = {
            personId: selectedPeople[ i ].id,
            selections: selectedPeople[ i ].awardValue ? buildPointsReward( selectedPeople[ i ].awardValue, state ) : []
        };
        recipientList.push( recipient );
    }
    return recipientList;
};

const buildPointsReward = ( awardValue, state ) => {
    const { id, rewardChoiceId, budgets } = selectedProgram( state );
    let selections = [];
    const pointsAward = {
        type: 'REWARD',
        programId: id,
        rewardChoiceId: rewardChoiceId,
        data: {
            rewardType: 'POINTS',
            points: {
                value: parseInt( awardValue )
            },
            deliveryType: 'DIRECT',
            budgets: [
                {
                    budgetId: budgets[ 0 ].id,
                    value: parseInt( awardValue )
                }
            ]
        }
    };
    selections.push( pointsAward );
    return selections;
};

const buildSharedSelections = ( state ) => {
    const { id, rewardChoiceId } = selectedProgram( state );
    const message = getMessage( state );
    const selectedBehaviorId = getSelectedBehaviorId( state );
    const selectedEcard = getSelectedEcard( state );
    const isPrivate = getPrivate( state );
    const sharedSelections = [];
    const messageSelection = {
        type: 'MESSAGE',
        data: { text: message || '' },
        programId: id,
        rewardChoiceId: rewardChoiceId
    };
            sharedSelections.push( messageSelection );

        if ( selectedBehaviorId ) {
            const behaviorSelection = {
                type: 'BEHAVIOR',
                programId: id,
                rewardChoiceId: rewardChoiceId,
                data: {
                    behaviorId: selectedBehaviorId
                }
            };
            sharedSelections.push( behaviorSelection ); 
        }
        if ( selectedEcard && selectedEcard.id ) {
            const ecardSelection = {
                type: 'REWARD',
                programId: id,
                rewardChoiceId: rewardChoiceId,
                data: {
                    rewardType: 'ECARD',
                    ecard: {
                        ecardId: selectedEcard.id
                    },
                    deliveryType: 'DIRECT'
                }

            };
            sharedSelections.push( ecardSelection );
        }
        const privacySelection = {
            type: 'VISIBILITY',
            programId: id,
            rewardChoiceId: rewardChoiceId,
            data: {
                value: isPrivate ? 'PRIVATE' : 'PUBLIC'
            }
        };
        sharedSelections.push( privacySelection );
        return sharedSelections;
};